{
  "attorney": {
    "header": {
      "title": "律师仪表板"
    },
    "nav": {
      "filingQueue": "申报队列",
      "approvalQueue": "审批队列",
      "clients": "我的客户",
      "correspondence": "往来信件",
      "deadlines": "截止日期",
      "jurisdictions": "管辖区域",
      "assignments": "管理分配",
      "backToDashboard": "返回仪表板"
    },
    "filingQueue": {
      "title": "申报队列",
      "loading": "正在加载申报队列...",
      "error": "加载申报队列时出错",
      "empty": "队列中没有申报",
      "allCountries": "所有国家",
      "allStatuses": "所有状态",
      "statusPending": "待处理",
      "statusFiled": "已提交",
      "refresh": "刷新"
    },
    "filingCard": {
      "allFiled": "全部已提交",
      "partiallyFiled": "进行中",
      "pending": "待处理",
      "client": "客户",
      "classes": "类别",
      "country": "国家",
      "status": "状态",
      "ipOfficeRef": "知识产权局编号",
      "actions": "操作",
      "jurisdictionsFiled": "个管辖区已提交"
    },
    "jurisdiction": {
      "pending": "待处理",
      "filed": "已提交",
      "accepted": "已接受",
      "registered": "已注册",
      "rejected": "已拒绝",
      "fileNow": "立即提交",
      "viewDocs": "查看文档",
      "view": "查看",
      "editRef": "编辑编号"
    },
    "fileNowModal": {
      "title": "在{{country}}提交",
      "applicationRef": "申请编号",
      "useReference": "在所有知识产权局表格中使用此编号：",
      "copy": "复制",
      "copied": "已复制！",
      "ipOfficePortal": "知识产权局门户",
      "openPortal": "打开门户",
      "instructions": "操作说明",
      "step1": "登录{{office}}门户",
      "step2": "开始新的商标申请",
      "step3": "在「您的编号」字段中输入「{{appId}}」",
      "step4": "上传生成的申报文件",
      "step5": "在知识产权局完成付款",
      "step6": "记录{{office}}的参考编号",
      "documents": "文档",
      "afterFiling": "提交后，输入知识产权局的参考编号：",
      "cancel": "取消",
      "markAsFiled": "标记为已提交",
      "marking": "正在标记..."
    },
    "approvalQueue": {
      "title": "审批队列",
      "loading": "正在加载审批队列...",
      "error": "加载审批队列时出错",
      "empty": "没有等待审批的任务",
      "allTypes": "所有类型",
      "officeAction": "官方通知回复",
      "opposition": "异议回复",
      "renewal": "续展申请",
      "refresh": "刷新"
    },
    "approvalCard": {
      "officeAction": "官方通知回复",
      "opposition": "异议回复",
      "renewal": "续展申请",
      "urgent": "紧急",
      "high": "高",
      "medium": "中",
      "low": "低",
      "successLikelihood": "成功可能性",
      "noSummary": "无可用摘要",
      "daysLeft": "剩余{{days}}天",
      "overdue": "已过期！",
      "review": "审核草稿"
    },
    "draftReview": {
      "title": "审核AI草稿",
      "summary": "摘要",
      "estimatedSuccess": "预估成功率",
      "keyArguments": "关键论点",
      "similarCases": "参考的类似案例",
      "draftContent": "草稿内容",
      "view": "查看",
      "edit": "编辑",
      "editPlaceholder": "编辑草稿...",
      "rejectReason": "拒绝原因",
      "rejectPlaceholder": "说明拒绝此草稿的原因...",
      "back": "返回",
      "reject": "拒绝",
      "confirmReject": "确认拒绝",
      "rejecting": "正在拒绝...",
      "approve": "批准",
      "approveWithChanges": "批准并修改",
      "approving": "正在批准..."
    }
  }
}
